import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Box} from '@mui/material'
import {Location} from 'react-router-dom'

interface FirstLoginLocationState {
    dIspStepInfo: DIspStepInfo
}

interface Props {
    location: Location<FirstLoginLocationState>
}

interface States {
    isLoadCompleted: boolean
}

class NatResidentFirstLoginMailSendCompletePage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
        }

        const locationState = this.props.location.state
        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : []

        if (!locationState) {
            window.location.href = `/resident/error`
            return
        }
    }

    componentDidMount(): void {
        this.setState({isLoadCompleted: true})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.firstLoginLocationState.dIspStepInfo}
                    nowStep={Step.MAIL_RECEIVE}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        メール受信
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <WideMainContainer>
                    <Box height={'15px'}/>
                    登録いただいたメールアドレスに確認メールを送信しました。<br/>
                    届いたメールに添付されたURLよりログインをお願い致します。<br/>
                    yahooメールなどをご利用の方で、メール受信フォルダにメールが見当たらない方は、迷惑メールフォルダをご確認ください。
                    <Box height={'20px'}/>
                </WideMainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginMailSendCompletePage)
